import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useWs } from "@/context/WorkspaceContext";

export function useWsData(path) {
  const { wid } = useWs();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async () => {
    if (!wid) return;
    try {
      const r = await api.get(`/workspaces/${wid}${path}`);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(e);
    }
  }, [wid, path]);
  useEffect(() => {
    setData(null);
    load();
  }, [load]);
  return { data, reload: load, wid, error };
}
